import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import {
  ponteImg,
  moutonPng,
  mt1Img,
  poulaillerWebp,
  testimonial1,
  testimonial2,
  africanJpg,
} from "../assets/images";

// Données des cartes
const articles = [
  {
    imgSrc: ponteImg,
    altText: "poule pondeuse",
    title: "Tout savoir sur les poules pondeuses",
    description: "Il existe plusieurs races de poules : pondeuse, couveuse, naine, ornement…",
    link: "/pondeuse",
    external: false,
  },
  {
    imgSrc: moutonPng,
    altText: "mouton",
    title: "Conseils pratiques pour réussir l'élevage",
    description: "Pour bien élever des moutons, le propriétaire doit aménager et équiper les lieux...",
    link: "/mouton_details",
    external: true,
  },
  {
    imgSrc: mt1Img,
    altText: "mouton",
    title: "Les Meilleures Pratiques pour le Soin",
    description: "Le soin des animaux est essentiel pour leur bien-être et productivité...",
    link: "/mouton",
    external: false,
  },
  {
    imgSrc: poulaillerWebp,
    altText: "poulailler",
    title: "Stratégies pour Maintenir la Santé",
    description: "La santé des animaux est un pilier de la production rentable...",
    link: "/Poulailler",
    external: false,
  },
];

// Données des témoignages
const testimonials = [
  {
    imgSrc: testimonial1,
    name: "M. OUEDRAOGO Souleymane",
    profession: "Eleveur",
    feedback: "Je travaille avec la société moul depuis plus de deux ans parce que les poussins et les aliments sont de très bonne qualité.",
  },
  {
    imgSrc: testimonial2,
    name: "M. Bouba Arouna",
    profession: "Eleveur",
    feedback: "La ponte ça va, les œufs sont de qualité et les poulettes sont en forme. Nous les nourrissons avec les cimens moul.",
  },
  {
    imgSrc: africanJpg,
    name: "Madame DJORE",
    profession: "Propriétaire de ferme",
    feedback: "Je suis propriétaire de ferme avicole composé de 2400 poules prête à pondre. Je bénéficie d'une très bonne assistance technique.",
  },
];

// Composant réutilisable Card
const Card = ({ imgSrc, altText, title, description, link, external }) => (
  <div className="card rounded-none bg-base-100">
    <figure>
      <img src={imgSrc} alt={altText} className="w-[348px] h-[206px] object-contain" loading="lazy" />
    </figure>
    <div className="card-body bg-white">
      <h2 className="card-title">{title}</h2>
      <div>{description}</div>
      <div className="card-actions justify-end">
        {external ? (
          <a href={link} target="_blank" rel="noopener noreferrer" className="btn btn-gray w-full sm:w-auto">
            Voir plus
          </a>
        ) : (
          <Link to={link} className="btn btn-gray w-full sm:w-auto">
            Voir plus
          </Link>
        )}
      </div>
    </div>
  </div>
);

// Composant réutilisable Testimonial
const Testimonial = ({ imgSrc, name, profession, feedback }) => (
  <div className="card rounded-none lg:card-side bg-base-100">
    <figure className="w-4/6 pl-5">
      <img src={imgSrc} alt={name} className="w-full  object-cover" loading="lazy" />
    </figure>
    <div className="card-body bg-white">
      <h2 className="card-title">
        {name}, <span className="text-gray-500 text-sm">{profession}</span>
      </h2>
      <div>{feedback}</div>
    </div>
  </div>
);

function Articles() {
  return (
    <div className="border-b-4">
      {/* Section Articles */}
      <div
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-offset="200"
        className="flex flex-col gap-8 lg:flex-row items-stretch justify-around lg:px-0 px-6 lg:py-5 py-8 2xl:mx-auto 2xl:container"
      >
        {articles.map((article, index) => (
          <Card key={index} {...article} />
        ))}
      </div>

      {/* Section Promotionnelle */}
      <div className="card bg-base-100 rounded-none flex flex-col lg:flex-row items-center gap-12 my-10 lg:justify-evenly lg:px-11 p-10 lg:py-28 py-8 2xl:mx-auto 2xl:container">
        <div className="text-2xl sm:text-3xl lg:text-4xl font-bold w-full lg:w-5/12 text-center lg:text-left">
          Besoin d'aliments de qualité pour vos animaux ?
        </div>
        <div className="flex justify-center w-full lg:w-auto my-auto">
          <Link
            to="/contact"
            onClick={() => window.scrollTo(0, 0)}
            className="flex items-center py-4 px-8 bg-primary text-white hover:bg-primary/90 dark:bg-white dark:hover:bg-gray-400 dark:text-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-700 rounded-lg"
          >
            Nous contacter
            
          </Link>
        </div>
      </div>

      {/* Section Témoignages */}
      <div className="text-4xl text-center text-black my-10 sm:px-96 md:px-20">
      <div className="bg-gray-300 p-1 mx-auto rounded-lg mb-2"></div>

        Ce qu'ils disent de nous
      <div className="bg-gray-300 p-1 mx-auto rounded-lg mt-2"></div>

      </div>
      <div
        data-aos="fade-left"
        data-aos-duration="1000"
        data-aos-offset="200"
        className="grid grid-cols-1 sm:grid-cols-2 gap-4 items-stretch justify-around lg:px-0 px-6 lg:py-5 py-8 2xl:mx-auto 2xl:container"
      >
        {testimonials.map((testimonial, index) => (
          <Testimonial key={index} {...testimonial} />
        ))}
      </div>
    </div>
  );
}

export default Articles;
